import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';

/**
 * UI-only Mark as Earned and allocation sections for flat-fee operating offline invoice payments.
 */
export const RecordPaymentEarnedAllocationFields = ({
  showMarkAsEarned,
  showAllocationFields,
  markAsEarnedChecked,
  onMarkAsEarnedChange,
  allocationTrustAccounts = [],
  selectedAllocationTrustAccount,
  onAllocationTrustChange,
  disableAllocationTrustSelection = false,
  transferToTrustAmount,
  onTransferToTrustAmountChange,
  temporaryFundAmount,
  onTemporaryFundAmountChange,
  markAsEarnedAmount,
  onMarkAsEarnedAmountChange,
  allocationErrors = {},
}) => {
  if (!showMarkAsEarned && !showAllocationFields) {
    return null;
  }

  return (
    <>
      {showMarkAsEarned && (
        <div className="d-flex align-items-center py-2 flex-wrap">
          <div className="col-12 col-sm-4 p-medium">Mark as Earned</div>
          <div className="col-12 col-sm-8 d-flex align-items-center">
            <Checkbox
              inputId="recordPaymentMarkEarnedFlag"
              checked={markAsEarnedChecked}
              onChange={(e) => onMarkAsEarnedChange(!!e.checked)}
            />
          </div>
        </div>
      )}

      {showAllocationFields && (
        <>
          <hr className="my-3 text-muted opacity-50" />

          <div className="py-1">
            <div className="p-medium fw-bold mb-2">Transfer to Trust Account</div>
            <div className="d-flex align-items-center py-2 flex-wrap">
              <div className="col-12 col-sm-4 p-medium">
                Trust
                <span className="text-danger">*</span>
              </div>
              <div className="col-12 col-sm-8">
                <Dropdown
                  className="input-shadow w-100 p-0"
                  options={allocationTrustAccounts}
                  value={selectedAllocationTrustAccount}
                  onChange={(e) => onAllocationTrustChange(e.value)}
                  optionLabel="account_name"
                  placeholder="Select"
                  filter
                  disabled={disableAllocationTrustSelection}
                  showClear={!disableAllocationTrustSelection && !!selectedAllocationTrustAccount}
                  aria-label="Allocation Trust"
                />
                {allocationErrors.trust_account && <span className="text-danger d-block mt-1">{allocationErrors.trust_account}</span>}
              </div>
            </div>
            <div className="d-flex align-items-center py-2 flex-wrap">
              <div className="col-12 col-sm-4 p-medium">Amount</div>
              <div className="col-12 col-sm-8">
                <InputNumber
                  className="input-shadow w-100"
                  value={transferToTrustAmount}
                  onValueChange={(e) => onTransferToTrustAmountChange(e.value)}
                  mode="currency"
                  currency="USD"
                  locale="en-US"
                  placeholder="Amount"
                  inputId="allocation-trust-amount"
                  aria-label="Transfer to Trust"
                />
                {allocationErrors.trust_amount && <span className="text-danger d-block mt-1">{allocationErrors.trust_amount}</span>}
              </div>
            </div>
          </div>

          <hr className="my-3 text-muted opacity-50" />

          <div className="py-1">
            <div className="p-medium fw-bold mb-2">Designate as temporary fund</div>
            <div className="d-flex align-items-center py-2 flex-wrap">
              <div className="col-12 col-sm-4 p-medium">Amount</div>
              <div className="col-12 col-sm-8">
                <InputNumber
                  className="input-shadow w-100"
                  value={temporaryFundAmount}
                  onValueChange={(e) => onTemporaryFundAmountChange(e.value)}
                  mode="currency"
                  currency="USD"
                  locale="en-US"
                  placeholder="Amount"
                  inputId="allocation-temporary-funds-amount"
                  aria-label="Temporary Funds"
                />
                {allocationErrors.temporary_funds_amount && (
                  <span className="text-danger d-block mt-1">{allocationErrors.temporary_funds_amount}</span>
                )}
              </div>
            </div>
          </div>

          <hr className="my-3 text-muted opacity-50" />

          <div className="py-1">
            <div className="p-medium fw-bold mb-2">Mark as Earned</div>
            <div className="d-flex align-items-center py-2 flex-wrap">
              <div className="col-12 col-sm-4 p-medium">Amount</div>
              <div className="col-12 col-sm-8">
                <InputNumber
                  className="input-shadow w-100"
                  value={markAsEarnedAmount}
                  onValueChange={(e) => onMarkAsEarnedAmountChange(e.value)}
                  mode="currency"
                  currency="USD"
                  locale="en-US"
                  placeholder="Amount"
                  inputId="allocation-earned-amount"
                  aria-label="Earned Amount"
                />
                {allocationErrors.earned_amount && <span className="text-danger d-block mt-1">{allocationErrors.earned_amount}</span>}
              </div>
            </div>
          </div>

          {allocationErrors.allocation_sum && <div className="text-danger py-1">{allocationErrors.allocation_sum}</div>}
        </>
      )}
    </>
  );
};
